var path = '/app/dashboard/templates/dashboard.vehicle-registration.lookups.html';
var html = "<vehicle-registration-lookups\n  lookups=\"vehicleRegistrationLookups\">\n</vehicle-registration-lookups>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;